import { match as onboarding_activity } from "../../../src/params/onboarding_activity.ts";

export const matchers = { onboarding_activity };